import { getDefaultClient } from '@arcubase/client-ts'

export type CLIJCodeSession = {
  sessionId: string
  jcode?: string
  status: string
  loginUrl?: string
  expiresAt?: string
}

export function getCLIJCodeSession(sessionId: string): Promise<CLIJCodeSession> {
  return getDefaultClient().get(`/auth/cli-jcode/sessions/${encodeURIComponent(sessionId)}`)
}

export function confirmCLIJCodeSession(
  sessionId: string,
  jcode: string
): Promise<CLIJCodeSession> {
  return getDefaultClient().post(
    `/auth/cli-jcode/sessions/${encodeURIComponent(sessionId)}/confirm`,
    { jcode }
  )
}
